// Constants
import { SettingsConstants } from '../constants'

// Libraries
import Vue from 'vue'
import Vuex from 'vuex'
import persistedState from 'vuex-persistedstate'
import vuexCache from 'vuex-cache'

// Utilities
import Logger from '../utility/loggerUtil'

// Vuex Stores
import actions from './actions'

import { address } from './address/module'
import { appElement } from './appElement/module'
import { applicationAppointment } from './applicationAppointment/module'
import { applicationCustomer } from './applicationCustomer/module'
import { applicationFieldTracking } from './applicationFieldTracking/module'
import { applicationIncome } from './applicationIncome/module'
import { applicationMarital } from './applicationMarital/module'
import { applicationRetailStore } from './applicationRetailStore/module'
import { applicationSession } from './applicationSession/module'
import { applicationVehicle } from './applicationVehicle/module'
import { brands } from './brands/module'
import { cards } from './cards/module'
import { config } from './config/module'
import { customer } from './customer/module'
import { display } from './display/module'
import { loans } from './loans/module'
import { offers } from './offers/module'
import { origination } from './origination/module'
import { payment } from './payment/module'
import { referral } from './referral/module'
import { session } from './session/module'
import { states } from './states/module'
import { store } from './store/module'

Vue.use(Vuex)

let debounceTimer

export default new Vuex.Store({
  plugins: [
    vuexCache({ timeout: SettingsConstants.cacheTimeout }),
    persistedState({
      paths: ['customer', 'origination', 'payment'], // Only store essential modules
      storage: window.sessionStorage,
      setState (key, state, storage) {
        clearTimeout(debounceTimer)

        debounceTimer = setTimeout(() => {
          try {
            storage.setItem(key, JSON.stringify(state))
          } catch (error) {
            // TODO: Figure out if there is a way to permanently deal with QuotaExceededError
            Logger.error('Error on store state')
            Logger.debug(error)
          }
        }, 500) // Debounce to try to avoid QuotaExceededError
      }
    })
  ],
  actions,
  modules: {
    address,
    appElement,
    applicationAppointment,
    applicationCustomer,
    applicationFieldTracking,
    applicationIncome,
    applicationMarital,
    applicationRetailStore,
    applicationSession,
    applicationVehicle,
    brands,
    cards,
    config,
    customer,
    display,
    loans,
    offers,
    origination,
    payment,
    session,
    states,
    store,
    referral
  }
})
